import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  // BehaviorSubject + async pipe en el template evita el
  // ExpressionChangedAfterItHasBeenCheckedError que ocurría cuando un
  // interceptor cambiaba el flag en el mismo ciclo de change detection en
  // que el SpinnerComponent leía el valor.
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  public readonly loading$: Observable<boolean> =
    this.loadingSubject.asObservable();

  setLoading(loading: boolean): void {
    this.loadingSubject.next(loading);
  }

  // Retención por compatibilidad con consumidores existentes que leen
  // imperativamente. Para el template usar `loading$ | async`.
  getLoading(): boolean {
    return this.loadingSubject.value;
  }
}
